import { User, Mail, Lock, Eye, EyeOff } from "lucide-react";
import { Link, useOutletContext } from "react-router-dom";
import IconField from "../components/IconField";

function LoginForm() {
  const {
    loginType,
    setLoginType,
    showPassword,
    setShowPassword,
    handleEmailBlur,
    handleLogin,
    loading,
  } = useOutletContext();

  return (
    <>
      <div className="text-center mb-6">
        <h2 className="text-2xl font-semibold mb-1 mt-6">Welcome Back!</h2>

        <p className="text-gray-500 text-sm">Please enter your credentials</p>
      </div>

      <form
        noValidate
        className="space-y-3 w-full max-w-sm mx-auto"
        onSubmit={handleLogin}
      >
        {loginType === "client" && (
          <IconField icon={User} iconSize={20}>
            <input
              type="text"
              name="clientId"
              id="clientId"
              placeholder="Customer ID"
              required
              className="block w-full border border-gray-300 rounded-lg shadow-sm pl-11 pr-3 py-3 text-sm placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-primaryColor focus:border-transparent bg-white"
            />
          </IconField>
        )}

        <IconField icon={Mail}>
          <input
            type="email"
            name="email"
            placeholder="Email"
            onBlur={handleEmailBlur}
            className="block w-full border border-gray-300 rounded-lg shadow-sm pl-11 pr-3 py-3 text-sm placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-primaryColor focus:border-transparent bg-white"
            required
          />
        </IconField>

        <IconField icon={Lock}>
          <input
            type={showPassword ? "text" : "password"}
            name="password"
            placeholder="Password"
            className="block w-full border border-gray-300 rounded-lg shadow-sm pl-11 pr-10 py-3 text-sm placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-primaryColor focus:border-transparent bg-white"
            required
          />

          <button
            type="button"
            onClick={() => setShowPassword((v) => !v)}
            className="absolute right-3 top-1/2 -translate-y-1/2"
            aria-label={showPassword ? "Hide password" : "Show password"}
          >
            {showPassword ? (
              <EyeOff size={20} className="text-primaryColor" />
            ) : (
              <Eye size={20} className="text-primaryColor" />
            )}
          </button>
        </IconField>

        <Link
          to="/forgot-password"
          className="block w-full text-right text-sm text-primaryColor hover:underline"
        >
          Forgot Password?
        </Link>

        <button
          type="submit"
          disabled={loading}
          className="w-full flex items-center justify-center bg-primaryColor text-white px-3 py-2 rounded-md text-sm hover:bg-secondaryColor transition-colors duration-300 disabled:cursor-not-allowed"
        >
          {loading ? "Logging In..." : "Login Now"}
        </button>

        <p className="text-sm text-center text-gray-500">
          {loginType === "staff" ? (
            <button
              type="button"
              className="text-primaryColor font-semibold hover:underline"
              onClick={() => setLoginType("client")}
            >
              Client Login
            </button>
          ) : (
            <button
              type="button"
              className="text-primaryColor font-semibold hover:underline"
              onClick={() => setLoginType("staff")}
            >
              Staff Login
            </button>
          )}
        </p>
      </form>
    </>
  );
}

export default LoginForm;
